import React from "react";
import { MimaButton, MimaDropdown, MimaInput, MimaText, Modal } from "../../components";
import { Formik } from "formik";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";

const InflowReviewModal = ({
  closeModal,
  onSubmit,
  loading,
  validationSchema,
  inflowData,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <>
        <MimaText variant="subtitleBold" mb={1}>
          Review Inflow Transaction
        </MimaText>

        <MimaText mb={2} width={38} align="center">
          Carry out review action on inflow of{" "}
          <span style={{ fontWeight: "700", color: "var(--color-primary)" }}>
            {amountFormatter(inflowData.currencyCode).format(
              inflowData.amountPaid
            )}{" "}
          </span>{" "}
          to{" "}
          <span style={{ fontWeight: "700", color: "var(--color-primary)" }}>
            {inflowData.business.tradingName}{" "}
          </span>
        </MimaText>

        <MimaText width={38} align="center" variant="bodyBold" mb={1}>
          {" "}
          More Information
        </MimaText>

        {inflowData?.invoice !== undefined && (
          <>
            <MimaText labelTitle="Invoice Number" mb={1} variant="bodyBold">
              {inflowData?.invoiceNumber}
            </MimaText>
            {inflowData?.invoice?.orders.map((x, i) => (
              <div key={i} className="modal__borderBottom">
                <div className="modal__beside">
                  <MimaText
                    labelTitle={`Invoice Item ${i + 1}`}
                    mb={1}
                    width={18}
                  >
                    {x.item}
                  </MimaText>
                  <MimaText
                    labelTitle={`Invoice Item ${i + 1} Total Price`}
                    mb={1}
                    width={18}
                  >
                    {x.itemPrice}
                  </MimaText>
                </div>
                <div className="modal__beside">
                  <MimaText
                    labelTitle={`Invoice Item ${i + 1} Quantity`}
                    mb={1}
                    width={18}
                  >
                    {x.quantity}
                  </MimaText>
                  <MimaText
                    labelTitle={`Invoice Item ${i + 1} Unit Price`}
                    mb={1}
                    width={18}
                  >
                    {x.unitPrice}
                  </MimaText>
                </div>
              </div>
            ))}
          </>
        )}

        <div className="modal__borderBottom">
          <MimaText labelTitle="Updated at" mb={1} width={38}>
            {moment(inflowData?.updatedAt).format("DD/MM/yy hh:mm a")}
          </MimaText>
          <MimaText labelTitle="Transaction Reference" mb={1} width={38}>
            {inflowData?.transactionReference}
          </MimaText>
        </div>

        <MimaText
          color="var(--color-error)"
          mb={2}
          mt={3}
          width={38}
          align="center"
        >
          Please note that action taken cannot be reversed
        </MimaText>

        <Formik
          initialValues={{
            action: "",
            amount: inflowData.amountPaid
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({
            handleBlur,
            handleChange,
            setFieldValue,
            values,
            errors,
            touched,
            handleSubmit,
          }) => (
            <>
              <MimaInput
                labelTitle="Amount Paid"
                type="number"
                placeholder="Enter Amount"
                id="amount"
                name="amount"
                value={values.amount}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.amount}
                touched={touched.amount}
                width={38}
              />
              <MimaDropdown
                labelTitle="Approval Action"
                placeholder="Select Approval action"
                name="action"
                value={values.action}
                id="action"
                data={[
                  { value: "APPROVED", key: "APPROVED" },
                  { value: "VOID", key: "VOID" },
                  { value: "REVERSED", key: "REVERSED" },
                ]}
                onChange={(data) => {
                  setFieldValue("action", data.key);
                }}
              />
              <MimaButton
                title="Confirm Action"
                type="submit"
                onClick={handleSubmit}
                width={38}
                buttonColor="var(--color-admin)"
                loading={loading}
              />
            </>
          )}
        </Formik>
      </>
    </Modal>
  );
};
export default InflowReviewModal;
